import DatePicker from "react-datepicker";
import styled from "styled-components";

const INPUT_HEIGHT = "29px";

export const Container = styled.div`
  font-size: 12px;
  padding: 0 0 35px 0;
  margin-right: 20px;
  border-bottom: 1px solid #afafaf;
`;

export const DatesContainer = styled.div`
  display: flex;
  margin-top: 15px;
`;

export const InputGroupContainer = styled.div`
  display: flex;
`;

export const InputContainer = styled.div`
  display: flex;
  margin-right: 40px;
`;

export const StyledDatePicker = styled(DatePicker)`
  width: 138px;
  height: ${INPUT_HEIGHT};
  padding-left: 10px;
  border: 1px solid ${({ theme }) => theme.buttonColor};
  border-radius: 3px 3px 3px 0;
  border-left: none;
  cursor: pointer;
`;

export const CalendarBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: ${INPUT_HEIGHT};
  height: ${INPUT_HEIGHT};
  background-color: ${({ theme }) => theme.buttonColor};
  border-radius: 3px 0 3px 3px;
`;

export const WeekdayContainer = styled.div`
  display: flex;
  align-items: center;
  font-size: 13px;
`;

export const StyledLabel = styled.label`
  display: flex;
  align-items: center;
  margin-right: 20px;
  margin-bottom: 0;
  cursor: pointer;
`;

export const StyledCheckbox = styled.input`
  width: 15px;
  height: 15px;
  margin-right: 6px;
  cursor: pointer;
`;

export const ModalActionContainer = styled.div`
  margin-top: 20px;
  margin-bottom: -15px;
`;

export const RemovePeriodButton = styled.button`
  height: 29px;
  margin-left: -6px;
  margin-right: 6px;
  font-weight: 600;
  font-size: 18px;
  opacity: 1;
  text-shadow: none;
  background-color: transparent;
  border: 0;

  &:after {
    content: "×";
  }
`;
